import React from 'react'
import { ReactComponent as ArrowScrollSvg} from '../../assets/svgs/arrows/Arrow_Scroll.svg';

const ArrowScrollIcon = () => (
    <div>
        <ArrowScrollSvg/>
    </div>
)

export default ArrowScrollIcon